import useSWR from 'swr'

import { FetchError } from '../../../../data/fetchError'
import { FetchResponse } from '../../../../data/fetchResponse'
import { FetchResult } from '../../../../data/fetchResult'
import { fetchJson } from '../../../../data/fetchers'
import { SupplierDetail, SupplierTemplate } from './model'

export function useSupplierById(id: string): FetchResult<SupplierDetail> {
  const { data, error, isLoading, mutate } = useSWR<
    FetchResponse<SupplierDetail>,
    FetchError
  >(`/SelfServices/Suppliers/${id}`, fetchJson<SupplierDetail>)

  return {
    data: data?.body,
    isLoading,
    error,
    mutate,
  }
}

export function useAllSupplierTemplates(): FetchResult<SupplierTemplate[]> {
  const { data, isLoading, error, mutate } = useSWR<
    FetchResponse<SupplierTemplate[]>,
    FetchError
  >(`/selfservices/suppliers/templates`, fetchJson<SupplierTemplate[]>)

  return {
    data: data?.body,
    isLoading,
    error,
    mutate,
  }
}
